// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"8a402d06","163":"cda6e9d4","187":"96eb0e19","254":"27788ae6","278":"7cb8e02f","312":"a7478275","446":"c4091126","453":"3b2771a0","518":"a3093664","548":"eee834d9","743":"5307042c"}[chunkId] + ".chunk.js";
};